import { ST } from "next/dist/shared/lib/utils";
import Image from "next/image";
import StraitLine from "../icons/StraitLine";
import TwoArrowConnection from "../icons/TwoArrowConnection";
import SmallTwoArrowConnection from "../icons/SmallTwoArrowConnection";
import TwoArrowForMibileView from "../icons/TwoArrowForMibileView";
import StraightLineReverse from "../icons/StraightLineReverse";

const VehicleHandoverLifecycle = () => {
  return (
    <div className="py-10 max-w-360 w-full mx-auto px-5 bg-white">
      <div className="text-center max-w-225 mx-auto">
        <h2 className="text-[28px] md:text-[28px]  md:text-4xl font-bold mb-4 text-[#04082C]">
          The Complete Vehicle Handover Lifecycle
        </h2>

        <p className="md:text-[16px] text-[#333] leading-6">
          Seamlessly manage the full vehicle handover with a SmartLink. Create
          an official starting record, detect changes upon origin and impact
          stamp, and automatically convert them into fair and transparent
          invoices.
        </p>
      </div>
      <div className="mt-5 md:mt-14 ">
        <div className="border border-[#DFDFDF] rounded-3xl  max-w-225 mx-auto p-4 flex flex-col md:flex-row gap-15 items-center">
          <div>
            <h3 className="text-[24px] md:text-[28px] capitalize font-montserrat font-bold text-[#333] mb-2.5">
              Create Drive
            </h3>
            <p className="text-[14px] text-[#7D7D7D] leading-5 font-openSans ">
              Enter owner, driver, and vehicle details to generate a SmartLink
              and begin the Drive stamping flow on mobile.
            </p>
          </div>
          <Image
            src="/images/vehicleLifecycle/create-drive.svg"
            alt="create drive"
            width={340}
            height={180}
            className=""
          ></Image>
        </div>
        <div className="md:flex hidden justify-center ">
          <StraitLine />
        </div>
        <div className="flex items-center md:hidden justify-center">
          <TwoArrowForMibileView count={1} />
        </div>
        {/* two cards start */}
        <div className="">
          <div className="border border-[#DFDFDF] rounded-3xl  max-w-[387px] mx-auto p-4 z-10">
            <Image
              src="/images/vehicleLifecycle/stamp-progress - Copy.svg"
              alt="control page"
              width={340}
              height={240}
              className=""
            ></Image>
            <div className="mt-5">
              <h3 className=" text-[24px] md:text-[28px]  font-montserrat font-bold leading-8 text-[#333] mb-2.5">
                Dedicated Stamp Page
              </h3>
              <p className="text-[14px] text-[#7D7D7D] leading-5 font-openSans ">
                Access your Drive stamp page using a Drive ID to open the
                SmartLink, view stamp progress, and interact with all records in
                one place.
              </p>
            </div>
          </div>
          <div className="hidden md:block">
            <TwoArrowConnection />
          </div>
          <div className="flex items-center md:hidden justify-center">
            <TwoArrowForMibileView />
          </div>
          <div className="flex md:gap-10 flex-col md:flex-row md:-mt-11.25 items-center justify-center">
            <div className="border border-[#DFDFDF] rounded-3xl  max-w-[395px] pt-4 pl-4 pb-4 mx-auto z-10">
              <div className="flex justify-between">
                <div className="flex items-start">
                  <Image
                    src="/images/vehicleLifecycle/origin-stamp-checkicon.svg"
                    alt="control page"
                    width={150}
                    height={100}
                    className=""
                  />
                  <Image
                    src="/images/vehicleLifecycle/blue-tik.svg"
                    alt="control page"
                    width={51}
                    height={43}
                    className=""
                  />
                </div>
                <Image
                  src="/images/vehicleLifecycle/origin-stamp-car.svg"
                  alt="control page"
                  width={162}
                  height={129}
                  className=""
                />
              </div>

              <div className="mt-14">
                <h3 className="text-[24px] md:text-[28px]  font-montserrat font-bold leading-8 text-[#333] mb-2.5">
                  ORIGIN STAMP
                </h3>
                <p className="text-[14px] text-[#7D7D7D] leading-5 font-openSans pr-4">
                  At departure, users start the Origin Stamp by capturing
                  vehicle identity and status, exterior condition, and interior
                  condition as the official starting record of the drive.
                </p>
              </div>
            </div>
            <div className="md:flex hidden items-center -rotate-90 -mx-2">
              <StraightLineReverse />
            </div>
            <div className="flex items-center md:hidden justify-center">
              <TwoArrowForMibileView count={1} />
            </div>
            <div className="border hidden md:block border-[#DFDFDF] rounded-md h-fit max-w-[430px] w-full mx-auto p-4 z-10">
              <Image
                src="/images/vehicleLifecycle/interactive-stamp.svg"
                alt="control page"
                width={350}
                height={240}
                className="mx-auto"
              ></Image>
              <div className="">
                <h3 className=" text-[24px] md:text-[20px]  font-montserrat font-bold leading-8 text-[#333] mb-2">
                  INTERACTIVE STAMPS
                </h3>
                <p className="text-[14px] text-[#7D7D7D] leading-5 font-openSans ">
                  Each handover generates an interactive Drive record where all
                  stamps are shown in one structured view for review and sharing
                  as drive evidence.
                </p>
              </div>
            </div>
            <div className="md:flex hidden items-center rotate-90 -mx-2">
              <StraitLine />
            </div>
            <div className="border border-[#DFDFDF] rounded-3xl h-[320px]  max-w-[395px] mx-auto p-4 z-10">
              <div className="flex gap-5 justify-center mb-5">
                <Image
                  src="/images/vehicleLifecycle/impact-stamp.svg"
                  alt="control page"
                  width={250}
                  height={150}
                  className=""
                />

                <Image
                  src="/images/vehicleLifecycle/u-turn-impact-stamp.svg"
                  alt="control page"
                  width={82}
                  height={129}
                  className=""
                />
              </div>
              <div className="">
                <h3 className=" text-[24px] md:text-[28px]  font-montserrat font-bold leading-8 text-[#333] mb-2.5">
                  IMPACT STAMP
                </h3>
                <p className="text-[14px] text-[#7D7D7D] leading-5 font-openSans ">
                  At return, users conduct the Impact Stamp while the system
                  compares return conditions to the Origin Stamp and highlights
                  all changes during the drive.
                </p>
              </div>
            </div>
            {/* for mobile interactive stamps */}
            <div className="flex items-center md:hidden justify-center">
              <TwoArrowForMibileView count={1} />
            </div>
            <div className="border md:hidden block border-[#DFDFDF] rounded-3xl  max-w-[395px] mx-auto p-5 md:pt-7.5 md:pl-10 md:pb-7.5 md:pr-7.5 z-10">
              <Image
                src="/images/vehicleLifecycle/interactive-stamp.svg"
                alt="control page"
                width={340}
                height={240}
                className=""
              ></Image>
              <div className="mt-5">
                <h3 className="text-[24px] md:text-[28px]  font-montserrat font-bold leading-8 text-[#333] mb-2.5">
                  INTERACTIVE STAMPS
                </h3>
                <p className="text-[14px] text-[#7D7D7D] leading-5 font-openSans ">
                  Each handover generates an interactive Drive record where all
                  stamps are shown in one structured view for review and sharing
                  as drive evidence.
                </p>
              </div>
            </div>
          </div>
          <div className="hidden md:block">
            <SmallTwoArrowConnection />
          </div>
          <div className="flex items-center md:hidden justify-center">
            <TwoArrowForMibileView />
          </div>
          <div className="flex max-w-[900px] mx-auto md:flex-row flex-col gap-2">
            <div className="border border-[#DFDFDF] rounded-3xl  max-w-[387px] mx-auto p-0 z-10">
              <Image
                src="/images/vehicleLifecycle/Pre-invoice.svg"
                alt="control page"
                width={500}
                height={240}
                className=""
              ></Image>
              <div className=" p-4">
                <h3 className=" text-[24px] md:text-[28px]  font-montserrat font-bold leading-8 text-[#333] mb-2.5">
                  PRE-DRIVE INVOICE
                </h3>
                <p className="text-[14px] text-[#7D7D7D] leading-5 font-openSans ">
                  Before departure, create a Pre-Drive Invoice using key inputs
                  such as mileage rate , and applicable fees to define the
                  expected cost structure for the drive.
                </p>
              </div>
            </div>
            <div className="flex items-center md:hidden justify-center">
              <TwoArrowForMibileView count={1} />
            </div>
            <div className="border border-[#DFDFDF] rounded-3xl  max-w-[387px] mx-auto z-10">
              <Image
                src="/images/vehicleLifecycle/post-invoice.svg"
                alt="control page"
                width={500}
                height={240}
                className=""
              ></Image>
              <div className=" p-4">
                <h3 className=" text-[24px] md:text-[28px]  font-montserrat font-bold leading-8 text-[#333] mb-2.5">
                  POST-DRIVE INVOICE
                </h3>
                <p className="text-[14px] text-[#7D7D7D] leading-5 font-openSans ">
                  After return, create a Post-Drive Invoice using the Impact
                  Stamp and the differences identified against the Origin Stamp
                  to adjust and finalize the cost structure for the drive, and
                  more.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleHandoverLifecycle;
